import { baseApi } from '@shared/api/baseApi'

export interface SetAutoRenewPayload {
  enabled: boolean
  payment_method_id?: number
  reason?: string | null
}

export const setAutoRenew = async (payload: SetAutoRenewPayload): Promise<void> => {
  await baseApi.patch('/api/subscription/auto-renew', payload)
}

export interface CancelReasonPayload {
  /** Причина обязательна (бэк: minLength 1, maxLength 1024), null не принимается */
  reason: string
}

/**
 * Сохранить причину отмены подписки для аналитики оттока.
 * auto_renew не меняет — у Tribute управление подпиской живёт в их Mini App,
 * куда мы редиректим после сбора причины.
 */
export const cancelReason = async (payload: CancelReasonPayload): Promise<void> => {
  await baseApi.post('/api/subscription/cancel-reason', payload)
}
